<script lang="ts">
  import MemberCount from "./MemberCount.svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import { formatter } from "$app/utils"
  import { type Snippet } from "svelte"
  import BillingIntervalButton from "./BillingIntervalButton.svelte"

  interface Props {
    discountSnippet?: Snippet
  }
  let { discountSnippet }: Props = $props()

  const activeClass = "bg-white !font-bold text-black"
</script>

<div class="w-full rounded-t py-4">
  <h2 class="text-xl text-gray-500 font-bold">
    {signupStore.selectedPlan.name} Plan Details
  </h2>

  <div class="grid grid-cols-3 gap-y-4 my-5">
    {#each signupStore.member_roles as role (role.id)}
      <MemberCount role={role.id} min={role.min} max={role.max} />
    {/each}
  </div>

  <div class="relative mt-6 flex justify-center">
    <BillingIntervalButton />
  </div>

  <div class="grid grid-cols-3 gap-2 mt-4">
    <div class="col-span-2">Subtotal</div>
    <div class="font-bold text-right">
      {formatter.format(signupStore.totalAmount)}
    </div>
  </div>

  {#if discountSnippet}
    {@render discountSnippet()}
  {:else}
    <div class="grid grid-cols-3 gap-2">
      <div class="col-span-2">Discount</div>

      <div class="font-bold text-right">
        - {formatter.format(signupStore.discount)}
      </div>
    </div>
  {/if}

  <hr class="text-gray-200 mt-2" />
  <div class="mt-4 text-xl leading-6 font-medium grid grid-cols-2 gap-3">
    <div>
      {#if signupStore.billingInterval === "month"}
        Monthly Total
      {:else if signupStore.billingInterval === "year"}
        Annual Total
      {/if}
    </div>
    <div class="font-semibold text-right">
      {formatter.format(signupStore.total)}
    </div>
  </div>

  {#if signupStore.selectedPlan.name !== "Free"}
    <div class="text-sm mt-2 text-right text-green-600">
      {#if signupStore.billingInterval == "year"}
        You save 18% by paying annually
      {:else}
        You could save 18% by paying annually
      {/if}
    </div>
  {/if}
</div>
